import axios from "axios";
import { BaseAPI } from "./BaseAPI";
export class CaptchaAPI extends BaseAPI {
  //獲取驗證碼
  async captcha() {
    return axios
      .get(`${this._getContext()}/captcha`, {
        responseType: "blob",
      })
      .then((res) => res.data);
  }
}

export default new CaptchaAPI();
